import { Box, Divider, Grid } from '@mui/material';
import { ReactNode } from 'react';

type PageFilterSectionProps = {
  leftContent: ReactNode;
  centerContent?: ReactNode;
  rightContent?: ReactNode;
};

export const PageFilterSection = (props: PageFilterSectionProps) => {
  const { leftContent, rightContent = undefined, centerContent = undefined } = props;
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Grid
          container
          spacing={2}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            alignItems: 'center',
            '& .MuiInputLabel-formControl': {
              backgroundColor: 'white',
              px: '5px',
            },
          }}
        >
          <Grid
            item
            xs
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}
          >
            {leftContent}
          </Grid>
          {centerContent && (
            <Grid item xs='auto'>
              {centerContent}
            </Grid>
          )}
          {rightContent && (
            <Grid item xs>
              {rightContent}
            </Grid>
          )}
        </Grid>
      </Box>
      <Divider />
    </>
  );
};
